import React from 'react';
import Dialog from 'rc-dialog';
import Modal from 'react-modal';

export default class Email extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: {
                email: 'Invalid Email Address',
                phoneNumber: 'Invalid Phone Number',
                fullName: 'Cannot be empty'
            },
            fullName: '',
            email: '',
            phoneNumber: ''
        };
    }

    handleEmail = (email) => {
        this.setState(Object.assign({}, this.state, {
            email: email,
            errors: Object.assign({}, this.state.errors, {
                email: this.validateEmail(email)
            })
        }));
    }

    handleChange = (field, validate = ()=>{}) => event => {
        const value = event.target.value;
        this.setState(Object.assign({},
            this.state,
            {
                [field]: value,
                errors: Object.assign({}, this.state.errors, {
                    [field]: validate(value)
                })
            }
        ));
    }

    validateFullName = fullName => !!fullName ? '' :  'Cannot be empty'

    validatePhoneNumber = phoneNumber =>
        /^[0-9()+\- ]+$/.test(String(phoneNumber)) ?
            '' :
            'Invalid Phone Number';

    validateEmail = email =>
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            .test(String(email).toLowerCase()) ?
            '' :
            'Invalid Email Address';

    handleSendPayslip = event => {
        event.preventDefault();
        console.log('send!');
        this.props.onSendPayslip(this.state);
    };
    

    render() {
        const { fullName, email, phoneNumber, errors } = this.state;
        const {isShowDialog, onCloseDialog} = this.props;

        return (
            <Modal
                isOpen={isShowDialog}
                parentSelector={() => document.querySelector('#form-container')}
                className='personal-info-modal'
                style={{
                    overlay: {
                        zIndex: 2
                    }
                }}
            >
                <form 
                    onSubmit={this.handleSendPayslip}
                >
                    <div className='row'>
                        <div className='col-sm-12 col-md-8 offset-md-2'>
                            <p>
                                Submit your details below to get the payslip.
                            </p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-12 col-md-8 offset-md-2'>
                            <div className={'pcb-input ' + (!!fullName && !!errors.fullName ? 'has-error' : '')}>
                                <label>
                                    YOUR NAME
                                </label>

                                <input
                                    type='fullName'
                                    placeholder='Key in your name'
                                    value={fullName}
                                    onChange={this.handleChange('fullName', this.validateFullName)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-12 col-md-8 offset-md-2'>
                            <div className={'pcb-input ' + (!!phoneNumber && !!errors.phoneNumber ? 'has-error' : '')}>
                                <label>
                                    YOUR PHONE NUMBER
                                </label>

                                <input
                                    type='phoneNumber'
                                    placeholder='Key in your phone number'
                                    value={phoneNumber}
                                    onChange={this.handleChange('phoneNumber', this.validatePhoneNumber)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-12 col-md-8 offset-md-2'>
                            <div className={'pcb-input ' + (!!email && !!errors.email ? 'has-error' : '')}>
                                <label>
                                    YOUR E-MAIL <i
                                        className="fa fa-question-circle"
                                        data-tip="By using payslip feature, you are automatically subscribed
                                            to our mailing list, of course you can unsubscribe at any time."
                                    ></i>
                                </label>

                                <input
                                    type='email'
                                    placeholder='Key in your email to receive a payslip.'
                                    value={email}
                                    onChange={this.handleChange('email', this.validateEmail)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className='row'>

                        <div className='col-sm-12 col-md-8 col-lg-4 offset-md-2'>
                            <input
                                className='pcb-button primary'
                                type="submit"
                                disabled={!email || !fullName || !phoneNumber || !!errors.email || !!errors.fullName || !!errors.phoneNumber}
                                value="GET PAYSLIP"
                                id="send-email"
                            />
                        </div>
                        <div className='col-sm-12 col-md-8 col-lg-4 offset-md-2 offset-lg-0'>
                            <button className='pcb-button' onClick={onCloseDialog}>
                                CANCEL
                            </button>
                        </div>
                    </div>
                </form>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Calculator/PersonalInfoForm.js